import { securedAxiosInstance } from "../axios";

class AnalyticsService {
  getOrganizations(startDate, endDate) {
    return securedAxiosInstance.get("/backoffice/analytics/retail/organizations", {
      params: {
        start: startDate,
        end: endDate,
      },
    });
  }

  getStores(organizationId, startDate, endDate) {
    return securedAxiosInstance.get("/backoffice/analytics/retail/stores", {
      params: {
        organization_id: organizationId,
        start: startDate,
        end: endDate,
      },
    });
  }

  getSellers(storeId, startDate, endDate) {
    return securedAxiosInstance.get("/backoffice/analytics/retail/sellers", {
      params: {
        store_id: storeId,
        start: startDate,
        end: endDate,
      },
    });
  }

  getGeneralAnalytics({ startDate, endDate, stores, organizationId, comparisonType }) {
    return securedAxiosInstance.get("/backoffice/analytics", {
      params: {
        start_date: startDate,
        end_date: endDate,
        stores,
        organization_id: organizationId,
        comparison_type: comparisonType,
      },
    });
  }
}

export default new AnalyticsService();
